// file client/src/lessons/les1-motiverende-gespreksvoering/config.js

export const LES1_CONFIG = {
  id: 'les1',
  title: 'Haal meer uit verandertaal!',
  description: 'Open vragen stellen en reflecteren om verandertaal te versterken',
  totalDuration: 340, // minutes
  modules: [
    {
      id: 'module1',
      title: 'Introductie: Wat ga je leren?',
      description: 'Introductie van de cursus',
      duration: 5,
      type: 'theory',
      prerequisites: [],
      isAlwaysAvailable: true,
      icon: '📚'
    },
    {
      id: 'module2',
      title: 'Vragen Stellen: Verdiep het Gesprek',
      description: 'Oefen met open vragen die het gesprek verdiepen',
      duration: 70,
      type: 'conversation',
      prerequisites: ['module1'],
      conversations: 2,
      passingCriteria: 'In deze trainingssessie oefen je met het stellen van open vragen. Je gaat een gesprek aan meteen virtuele cliënt. Ga een natuurlijk gesprek aan met de cliënt, en stel open vragen om het gesprek te verdiepen. Zodra je vijf open vragen hebt gesteld heb je de opdracht behaald. Je krijgt vervolgens feedback op je gesprekstechnieken, en krijgt vervolgens een nieuwe casus om nogmaals te oefenen. Let op: Stel niet alleen maar vragen achter elkaar, laat de cliënt weten dat je luistert door te reageren op wat de cliënt zegt! Als je vijf open vragen hebt gesteld, klik dan op Evalueer gesprek om feedback te krijgen op je gesprekstechniek en na te gaan of je de opdracht hebt behaald.',
      icon: '💬'
    },
    {
      id: 'module3',
      title: 'Vragen Stellen: Nodig uit tot Verandertaal',
      description: 'Oefen met vragen die verandertaal uitlokken',
      duration: 65,
      type: 'conversation',
      prerequisites: ['module2'],
      conversations: 2,
      passingCriteria: 'In een gesimuleerd gesprek open vragen stellen naar alle vier de categorieën verandertaal: wensen, redenen, noodzaak en vermogen om te veranderen.',
      icon: '🎯'
    },
    {
      id: 'module4',
      title: 'Reflecteren',
      description: 'Leer reflectietechnieken toepassen',
      duration: 65, 
      type: 'conversation',
      prerequisites: ['module3'],
      conversations: 2,
      passingCriteria: 'Vier complexe reflecties formuleren in een simulatiegesprek.',
      icon: '🪞'
    },
    {
      id: 'module5',
      title: 'Reflecteren op Verandertaal',
      description: 'Verdiep reflecties specifiek op verandertaal',
      duration: 65,
      type: 'conversation', 
      prerequisites: ['module4'],
      conversations: 2,
      passingCriteria: 'In een simulatiegesprek vijf keer reageren op verandertaal met een reflectie.',
      icon: '✨'
    },
    {
      id: 'module6',
      title: 'Eindopdracht: Integratie van Alle Vaardigheden',
      description: 'Pas alle geleerde MVG-vaardigheden geïntegreerd toe in een volledig gesprek',
      duration: 70,
      type: 'conversation',
      prerequisites: ['module5'],
      conversations: 2,
      passingCriteria: 'In elk simulatiegesprek minimaal 6 uitingen van verandertaal uitlokken bij de cliënt, door alle geleerde MVG-vaardigheden geïntegreerd toe te passen.',
      icon: '🏆'
    }
  ],
  extraModules: [
    {
      id: 'extra-verandertaal',
      title: 'Extra Kennis: Verandertaal Herkennen',
      description: 'Optionele module voor het herkennen van verandertaal',
      duration: 25,
      type: 'classification',
      prerequisites: [],
      isOptional: true,
      isAlwaysAvailable: true, // Always unlocked!
      icon: '🔍'
    }
  ],
  completionCriteria: {
    requiredModules: ['module1', 'module2', 'module3', 'module4', 'module5', 'module6'],
    minimumScore: 7
  }
};

// Helper functions
export const getAvailableModules = (userProgress = []) => {
  const completedModuleIds = userProgress.map(p => p.moduleId);
  
  // Get main modules based on prerequisites
  const availableMainModules = LES1_CONFIG.modules.filter(module => {
    // Always available modules
    if (module.isAlwaysAvailable) return true;
    
    // Check if all prerequisites are completed
    return module.prerequisites.every(prereq => 
      completedModuleIds.includes(prereq)
    );
  });

  // Get extra modules - always include modules marked as always available
  const availableExtraModules = LES1_CONFIG.extraModules.filter(module => {
    // Always available modules (like extra knowledge modules)
    if (module.isAlwaysAvailable) return true;
    
    // Check prerequisites for other extra modules
    return module.prerequisites.every(prereq => 
      completedModuleIds.includes(prereq)
    );
  });

  return [...availableMainModules, ...availableExtraModules];
};

export const getModuleById = (moduleId) => {
  const allModules = [...LES1_CONFIG.modules, ...LES1_CONFIG.extraModules];
  return allModules.find(module => module.id === moduleId);
};

export const getNextModule = (currentModuleId, userProgress = []) => {
  const currentIndex = LES1_CONFIG.modules.findIndex(m => m.id === currentModuleId);
  if (currentIndex === -1 || currentIndex === LES1_CONFIG.modules.length - 1) {
    return null; // No next module
  }
  
  const nextModule = LES1_CONFIG.modules[currentIndex + 1];
  const availableModules = getAvailableModules(userProgress);
  
  return availableModules.find(m => m.id === nextModule.id) || null;
};